import * as React from "react";
import styled from "styled-components";
import {
  ConstBreakPoint,
  ConstColor,
  ConstHeight,
  ConstZIndex,
} from "../../../config/styles_const/styles_const";
import { AppNotificationMessage } from "../../../domain/model/app_notification_message";
import AppNotificationWithText from "./app_notification_with_text";

interface IProps {
  onClose: (id: string) => (e: any) => void;
  appNotificationMessages: AppNotificationMessage[];
}

const AppNotificationWithTexts: React.FC<IProps> = (props) => {
  const { appNotificationMessages, onClose } = props;

  return (
    <Wrapper>
      {appNotificationMessages.map(
        (appNotificationMessage: AppNotificationMessage) => {
          const isHidden: boolean = appNotificationMessage.isHidden;
          const id: string = appNotificationMessage.id;

          if (!isHidden) {
            return (
              <AppNotificationWithText
                key={id}
                appNotificationMessage={appNotificationMessage}
                onClose={onClose}
              />
            );
          } else {
            return;
          }
        }
      )}
    </Wrapper>
  );
};

export default AppNotificationWithTexts;

const Wrapper = styled.div`
  position: absolute;
  top: ${ConstHeight.HeaderHeightSp};
  right: 0;
  left: 0;
  z-index: ${ConstZIndex.notificationCenter};
  color: ${ConstColor.White};
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    top: ${ConstHeight.HeaderHeight};
  }
`;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/app_notification_with_texts.tsx